import React from 'react';
import type { NavLinkProps } from 'react-router-dom';
import { NavLink } from 'react-router-dom';
import { bootstrappedData } from 'utils/bootstrap';

function RailsLink(
  props: Omit<React.PropsWithoutRef<NavLinkProps>, 'children'> &
    React.RefAttributes<HTMLAnchorElement> & {
      'data-testid'?: string;
      'data-fs-element'?: string;
      children: React.ReactNode;
    }
): ReturnType<typeof NavLink> {
  let to = props.to as string;
  if (to.startsWith('/') && !to.startsWith(`/${bootstrappedData.account.id}/`)) {
    to = `/${bootstrappedData.account.id}${to}`;
  }

  return (
    <a
      data-testid={props['data-testid']}
      data-fs-element={props['data-fs-element']}
      href={to}
      className={typeof props.className === 'string' ? props.className : undefined}
    >
      {props.children}
    </a>
  );
}

export default window.location.hostname !== 'localhost' ? RailsLink : NavLink;
